module.exports = __webpack_public_path__ + "static/media/terms.6ba90a78.svg";